module finadai.app.payments.list {
  export var NAME = 'finadai.payments.list';
  class PaymentsListController {
    paymentStatus: string[] = ['payment_pending', 'declined', 'expired', 'paid', 'refunded', 'partially_refunded', 'charged_back', 'pre_authorized', 'voided'];
    filters: any = { with: '', limit: 1000, gtd_paid_at: window.moment().subtract(1, 'days').toDate(), ltd_paid_at: window.moment().toDate() };
    query = { order: '-created_at._date', limit: 10, page: 1 }
    promise: ng.IHttpPromise<models.http.responses.Records<models.Payment>>;
    payments: models.Payment[];
    constructor(private paymentsService: services.PaymentsService, $filter, $scope) {
      this.filters.status = 'paid';
    }
    search() {
      var _filters = angular.copy(this.filters);
      _filters.gtd_paid_at = _filters.gtd_paid_at != null ? window.moment(_filters.gtd_paid_at).format('YYYY-MM-DD') : null;
      _filters.ltd_paid_at = _filters.ltd_paid_at != null ? window.moment(_filters.ltd_paid_at).format('YYYY-MM-DD') : null;
      _filters.with = "negotiation,negotiation.customer";
      this.promise = this.paymentsService.getAll(_filters).then(response => {
        this.payments = response.data.data;
        return response;
      });
    }
    download() {
          var _filters = angular.copy(this.filters);
          _filters.gtd_paid_at = _filters.gtd_paid_at != null ? window.moment(_filters.gtd_paid_at).format('YYYY-MM-DD') : null;
          _filters.ltd_paid_at = _filters.ltd_paid_at != null ? window.moment(_filters.ltd_paid_at).format('YYYY-MM-DD') : null;

          this.paymentsService.downloadActivities(_filters).then(response => {
              if(response.status == 200){
                  window.location.href = response.data.url;
              }
          });
      }
  }
  export function run() {
    var list = angular.module(NAME, []);
    list.controller('PaymentsListController', PaymentsListController);
  }
} finadai.app.payments.list.run();